import { Bills } from "@hagerty/self-service-components/payments";
import styles from "./Billing.module.scss";
import { BillingDetails, phoneNumbers } from "shared";

type BillingProps = {
  billingDetails: BillingDetails;
};

export const Billing = ({ billingDetails }: BillingProps) => {
  return (
    <div className={styles.container}>
      <Bills
        isLoading={false}
        bills={[...billingDetails.coreBills, ...billingDetails.apexBills]}
        apexBillPhoneNumber={{
          href: `tel:${phoneNumbers.apex}`,
          formatted: phoneNumbers.apex,
        }}
        returnButtonLabel="Return to Account Dashboard"
        returnUrl={window.location.href}
      />
    </div>
  );
};
